import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { enqueueSnackbar } from 'actions';
import clsx from 'clsx';
import moment from 'moment';
import { Button, TextField, Card, Grid, CardHeader, CardContent, Tabs, Tab, Typography, Box, Divider } from '@mui/material';
import _ from 'underscore';
import { SelectField } from 'components';

import { SetFormState, GetSiteList } from '../../actions/HostToolsActions';

const useStyles = makeStyles(theme => ({
	root: {},
}));

const SiteListDialogForm = (props) => {
	const { className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const [availableDates, setAvailableDates] = useState([]);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.hostToolsReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const userRole = useSelector(state => state.session.user.role);
	const siteListDates = useSelector((state) => state.hostToolsReducer.siteListDates);

	// const distinctMocnActivationDatesF = [
	// 	...new Map(
	// 		(clustersInfo.mocnActivationDatesF ?? []).map(item => [
	// 			item.value,
	// 			{ text: item.text, value: item.value }
	// 		])
	// 	).values()
	// ];

	const _handleChange = event => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value
			},
			touched: {
				...formState.touched,
				[event.target.name]: true
			}
		});
	};

	const _exportData = () => {
		dispatch(GetSiteList(userId, formState.values.mocnActivationDateF));
	};

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<Grid container spacing={2}>
				<Grid item md={12} xs={12}>
					<Card>
						<CardHeader title="Site List - CRQs" style={{ paddingBottom: 0 }} />
						<CardContent>
							<Grid container spacing={2}>
								<Grid item md={3} xs={3}>
									<SelectField
										id="mocnActivationDateF"
										name="mocnActivationDateF"
										hintText="MOCN Activation Date (F)"
										defaultValue=""
										menuItems={(siteListDates) || []}
										value={formState.values.mocnActivationDateF}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<Button
										onClick={_exportData}
										color="secondary"
										size="small"
										variant="contained"
										style={{ height: '100%' }}
										disabled={!(
											formState.values.mocnActivationDateF
										)}
									>
										Export Data
									</Button>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</div >
	);
};

SiteListDialogForm.propTypes = {
	className: PropTypes.string
};

export default SiteListDialogForm;
